import { useNavigation } from "@react-navigation/native";
import { createContext, useContext, useState } from "react";
import { api } from "../api/api";
import UserContext from "./user";

interface ClientContextData {
  clients: any;
  setClients: any;
  clientsSelects: any;
  setClientsSelects: any;
  getClients(): Promise<void>;
  registerClient(data: any): Promise<void>;
  updateDataClient(data: any, id: number): Promise<void>;
}

const ClientContext = createContext({} as ClientContextData);

export function ClientProvider({ children }) {
  const navigation = useNavigation();
  const { user } = useContext(UserContext);
  const [clients, setClients] = useState([]);
  const [clientsSelects, setClientsSelects] = useState([]);

  async function getClients() {
    await api.get('/clients').then((response) => {
        let drivers: any = [];
        response.data.clients.map((item: any) => {
            drivers.push({label:item.name, value: item.id});
        });
        console.log(drivers);
        setClients(response.data.clients);
        setClientsSelects(drivers);
    })
    .catch((err) => {
        console.log('getClients', err);
        if(err?.response?.status === 401){
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        }
        return err;
    })
  }

  async function updateDataClient(data: any, id: number) {
    await api.put(`/clients/${id}`, data).then((response) => {
        console.log('save => ', response.data);
    })
    .catch((err) => {
        console.log('updateDataClient', err);
        if(err?.response?.status === 401){
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        }
        return err;
    })
  }

  async function registerClient(data: any) {
    await api.post('/clients', data).then((response) => {
        console.log(response.data);
    })
    .catch((err) => {
        console.log('registerClient', err);
        if(err?.response?.status === 401){
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        }
        return err;
    })
  }

  return (
    <ClientContext.Provider value={{ clients,
      clientsSelects,
      setClients,
      setClientsSelects,
      getClients,
      registerClient,
      updateDataClient
    }}>
      {children}
    </ClientContext.Provider>
  );
}

export default ClientContext;
